module.exports = __webpack_public_path__ + "img/Ac.5baba3fb.png";